// https://vuex.vuejs.org/en/mutations.html
import { set } from '@/utils/vuex'
export default {
  setUser: set('user'),
  setCompany: set('company'),
  setSites: set('sites'),
  setSite: set('site')
}
